import React from "react";
var __jsx = React.createElement;
import Image from "next/image";
import { UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Centred empty / error state with an icon badge, message and optional retry. */
export function StateView(_ref) {
  var icon = _ref.icon,
    iconImageSrc = _ref.iconImageSrc,
    title = _ref.title,
    description = _ref.description,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "base" : _ref$intent,
    onRetry = _ref.onRetry;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    role: "status",
    className: "flex h-full min-h-[14rem] flex-col items-center justify-center gap-3 p-8 text-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex h-12 w-12 items-center justify-center rounded-sds-full ".concat(iconImageSrc ? "" : intent === "urgent" ? "bg-sds-urgent-tertiary text-sds-urgent-default" : "bg-sds-base-secondary text-sds-base-tertiary")
  }, iconImageSrc ? /*#__PURE__*/React.createElement(Image, {
    src: iconImageSrc,
    alt: "",
    width: 28,
    height: 28,
    className: "h-7 w-7"
  }) : icon ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: "h-5 w-5"
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "flex max-w-sm flex-col gap-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-strong text-sds-base-default"
  }, title), description ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-secondary"
  }, description) : null), onRetry ? /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "data-testid": "state-view-retry",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.STATE_VIEW_RETRY);
      onRetry();
    },
    className: "mt-1 h-9 rounded-sds-100 border border-sds-base-default px-4 text-style-body-small-strong text-sds-base-secondary hover:text-sds-base-default"
  }, t("try_again", {
    defaultValue: "Try again"
  })) : null);
}